import { DATASTRATEGY, IEntity } from '@dch/entity-manager';
import { SessionStorageStrategy } from '@dch/entity-manager/lib/storage/strategies/session-storage.strategy';

export const CALL_DETAILS_ENTITY: IEntity<string> & { responseType: string } = {
  requestHeaders: ['language'],
  rel: 'bd:flsbillcalldetaildocument',
  url: '/rest/bill-downloader/customer/{cdbId}/billingAccount/fls/{billingAccountNumber}/billCallDetailsDocument/{documentId}',
  version: 'v1',
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_WITH_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
  // Note: used to avoid the response to be parsed as JSON by EM
  responseType: 'text',
};
